module.exports = __webpack_public_path__ + "img/Logotipo_CE.c0cfdae9.svg";